import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NavigateBefore.js
// module id = 4991
// module chunks = 2